﻿import React from 'react';
import { useNavigate, useLocation, useParams } from "react-router";

export const withRouter = WrappedComponent => function WithRouter(props) {
    const navigate = useNavigate();
    const location = useLocation();
    const params = useParams();

    return (
        <WrappedComponent
            {...props}
            navigate={navigate}
            location={location}
            params={params}
        />
    );
};